import createReactComponent from '../createReactComponent';
export default createReactComponent('compass', 'IconCompass', [
  ['path', { d: 'M8 16l2 -6l6 -2l-2 6l-6 2', key: 'svg-0' }],
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-1' }],
  ['path', { d: 'M12 3l0 2', key: 'svg-2' }],
  ['path', { d: 'M12 19l0 2', key: 'svg-3' }],
  ['path', { d: 'M3 12l2 0', key: 'svg-4' }],
  ['path', { d: 'M19 12l2 0', key: 'svg-5' }],
]);
